import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FormLlmInterfaceQueryVariables = Types.Exact<{
  formId: Types.Scalars['ID']['input'];
}>;


export type FormLlmInterfaceQuery = { __typename: 'PharosQuery', form: { __typename: 'FormType', id: string, llmInterface: { __typename: 'LlmInterfaceType', id: string } | null } | null };


export const FormLlmInterfaceDocument = gql`
    query formLlmInterface($formId: ID!) {
  form(id: $formId) {
    id
    llmInterface {
      id
    }
  }
}
    `;

/**
 * __useFormLlmInterfaceQuery__
 *
 * To run a query within a React component, call `useFormLlmInterfaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormLlmInterfaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormLlmInterfaceQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormLlmInterfaceQuery(baseOptions: Apollo.QueryHookOptions<FormLlmInterfaceQuery, FormLlmInterfaceQueryVariables> & ({ variables: FormLlmInterfaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormLlmInterfaceQuery, FormLlmInterfaceQueryVariables>(FormLlmInterfaceDocument, options);
      }
export function useFormLlmInterfaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormLlmInterfaceQuery, FormLlmInterfaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormLlmInterfaceQuery, FormLlmInterfaceQueryVariables>(FormLlmInterfaceDocument, options);
        }
export function useFormLlmInterfaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FormLlmInterfaceQuery, FormLlmInterfaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormLlmInterfaceQuery, FormLlmInterfaceQueryVariables>(FormLlmInterfaceDocument, options);
        }
export type FormLlmInterfaceQueryHookResult = ReturnType<typeof useFormLlmInterfaceQuery>;
export type FormLlmInterfaceLazyQueryHookResult = ReturnType<typeof useFormLlmInterfaceLazyQuery>;
export type FormLlmInterfaceSuspenseQueryHookResult = ReturnType<typeof useFormLlmInterfaceSuspenseQuery>;
export type FormLlmInterfaceQueryResult = Apollo.QueryResult<FormLlmInterfaceQuery, FormLlmInterfaceQueryVariables>;